import React from "react";
import "../Styles/privacy-policy-section.css";
import PrivacyPdf from "../assests/pdf/WedLuk_Privacy_Policy_full.pdf";

export default function PrivacyPolicySection() {
  return (
    <section className="privacy-policy-container">
      <div className="privacy-card">
        <h2 className="privacy-title">Privacy Policy</h2>

        {/* <p className="privacy-effective">
          <strong>Effective Date:</strong> 15 April 2026
        </p> */}

        <p className="privacy-description">
          <strong>WedLuk Matrimonial Platform</strong>
        </p>

        <p className="privacy-description">
          Welkin Tech Bridge Inc. ("Company", "We", "Us", "Our"), a subsidiary
          of HayathSys Consulting Services Inc., owns and operates the WedLuk
          matrimonial platform through its mobile application and website.
        </p>

        <p className="privacy-description">
          This Privacy Policy explains how we collect, use, store, disclose, and
          protect your personal information when you use WedLuk. It applies to
          users worldwide, including India, Canada, Europe, the United States,
          and other jurisdictions.
        </p>

        <p className="privacy-description">
          By accessing or using WedLuk, you acknowledge that you have read,
          understood, and agree to the data collection and processing practices
          described in this Privacy Policy.
        </p>

        <a
          href={PrivacyPdf}
          target="_blank"
          rel="noopener noreferrer"
          className="privacy-link"
        >
          See Full Privacy Policy ❯
        </a>
      </div>
    </section>
  );
}
